import { createFileRoute } from '@tanstack/react-router';
import ControlTemplateDetailPage from '@/pages/(protected)/workspaces/[workspaceId]/templates/control-detail';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/templates/control/$controlId/'
)({
  component: ControlTemplateDetailPage,
});
